module.exports = __webpack_public_path__ + "img/logo_rmid.fc7f15b1.png";